module.exports = __webpack_public_path__ + "static/media/ethereum-logo.da8858be.png";